import { render } from "./MobileCustomListsPage.vue?vue&type=template&id=0f7cdb88&scoped=true"
import script from "./MobileCustomListsPage.vue?vue&type=script&lang=js"
export * from "./MobileCustomListsPage.vue?vue&type=script&lang=js"

import "./MobileCustomListsPage.vue?vue&type=style&index=0&id=0f7cdb88&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7cdb88"]])

export default __exports__